import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import {
  KEY_LANG,
  POINT_CONFIG,
  STATUS_USER,
  TICKETS_CONSTANT,
} from '../../../../const';
import { UserService } from '../../../../services/user.service';
import { TicketsService } from '../../../../services/tickets.service';
import { ActivatedRoute, Router } from '@angular/router';
import { ObjLanguage } from '../../../../inteface';
import {
  TuiAlertService,
  TuiAppearance,
  TuiButton,
  TuiGroup,
  TuiIcon,
} from '@taiga-ui/core';
import { TuiBlock, TuiButtonGroup, TuiRadio, TuiCheckbox } from '@taiga-ui/kit';
import { environment } from '../../../../../environments/environment';
import { FormControl, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { ROUTES_CONST } from '../../../../const/menu';
import { TranslocoService, TranslocoDirective } from '@jsverse/transloco';

@Component({
  selector: 'app-ticket',
  standalone: true,
  imports: [
    CommonModule,
    TuiAppearance,
    TuiButton,
    TuiIcon,
    TuiButtonGroup,
    ReactiveFormsModule,
    TuiBlock,
    TuiGroup,
    TuiRadio,
    TuiCheckbox,
    TranslocoDirective,
  ],
  templateUrl: './ticket.component.html',
  styleUrl: './ticket.component.less',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TicketComponent {
  environment = environment;
  KEY_LANG = KEY_LANG;
  lang: ObjLanguage;
  systemText;
  numbTicket: number;
  currentTicket;
  thisQuestions;
  questionsCount: number;
  userAnswer = [];
  radioAns;
  popover;
  viewTicket = 0;
  showResults = false;
  ROUTES_CONST = ROUTES_CONST;
  currentUser;
  /** Результат последнего прохождения билета для шаринга (correct, total, ticketIndex) */
  lastShareResult: {
    correct: number;
    total: number;
    ticketIndex: number;
  } | null = null;

  categoryPerson = [
    { key: 'Parent', name: 'Родитель' },
    { key: 'Adult', name: 'Взрослый' },
    { key: 'Child', name: 'Ребенок' },
  ];

  protected type2QuestionsForm = new FormGroup({
    type2QuestionsValue: new FormControl(),
  });
  protected type3QuestionsForm = new FormGroup({
    0: new FormControl(false),
    1: new FormControl(false),
    2: new FormControl(false),
    3: new FormControl(false),
    4: new FormControl(false),
    5: new FormControl(false),
    6: new FormControl(false),
    7: new FormControl(false),
    8: new FormControl(false),
    9: new FormControl(false),
  });

  private readonly alerts = inject(TuiAlertService);
  private readonly translocoService = inject(TranslocoService);

  constructor(
    private activateRoute: ActivatedRoute,
    private dataUser: UserService,
    private ticketsService: TicketsService,
    public router: Router,
  ) {}

  ngOnInit() {
    this.currentUser = this.dataUser.user;
    console.log('currentUser Ticket', this.currentUser);
    this.numbTicket = this.activateRoute.snapshot.params['ticketId'] * 1 + 1;
    this.currentTicket =
      TICKETS_CONSTANT[this.activateRoute.snapshot.params['ticketId']];
    this.thisQuestions = this.currentTicket.questions;
    this.questionsCount = this.currentTicket.questions.length;
    console.log('thisQuestions', this.thisQuestions);
  }

  segmentChanged(event) {
    console.log(event);
  }

  btnAnswerType1(numb: number, ans: number) {
    console.log(numb, ans);
    if (!this.userAnswer[numb]) {
      this.userAnswer[numb] = {};
    }
    this.userAnswer[numb] = ans;
    this.viewTicket = this.viewTicket + 1;
    console.log('this.userAnswer', this.userAnswer);
    this.isLastQuestion();
  }
  radioAnswer(indxAns, answer) {
    console.log(indxAns, answer);
    this.radioAns = indxAns;
  }
  btnAnswerType2(numb: number, ans) {
    console.log(numb, ans);
    if (!this.userAnswer[numb]) {
      this.userAnswer[numb] = {};
    }
    this.userAnswer[numb] = this.radioAns;
    this.radioAns = null;
    this.viewTicket = this.viewTicket + 1;
    console.log('this.userAnswer', this.userAnswer);
    this.isLastQuestion();
  }

  btnAnswerType3(numb: number, ans) {
    console.log(numb, ans);
    if (!this.userAnswer[numb]) {
      this.userAnswer[numb] = {};
    }
    this.userAnswer[numb] = ans;
    this.viewTicket = this.viewTicket + 1;
    console.log('this.userAnswer', this.userAnswer);
    this.isLastQuestion();
  }

  addNewTicket(n, m) {
    if (this.currentUser.questions[n]) {
      if (this.currentUser.questions[n].s == 0) {
        this.currentUser.questions[n].s = m;
      }
    } else {
      this.currentUser.questions[n] = {
        a: [],
        s: m,
      };
    }
  }

  isLastQuestion(): void {
    if (this.viewTicket == this.questionsCount) {
      this.getResultTest();
    }
  }

  pointsCulculate() {
    let point = 0;
    let trueAnswer = 0;
    this.thisQuestions.forEach((question, index) => {
      if (question.type === 1) {
        if (this.userAnswer[index] == question.trueA) {
          point += POINT_CONFIG.addPointTrueAns;
          trueAnswer += 1;
        }
      } else if (question.type === 2) {
        if (this.userAnswer[index] == question.trueA) {
          point += POINT_CONFIG.addPointTrueAns;
          trueAnswer += 1;
        }
      } else if (question.type === 3) {
        let statusAnswer = 0;
        this.userAnswer[index].forEach((answer) => {
          if (answer.state === answer.checked) {
            statusAnswer += 1;
          }
        });
        if (this.userAnswer[index].length === statusAnswer) {
          point += POINT_CONFIG.addPointTrueAns;
          trueAnswer += 1;
        }
      }
    });
    console.log(
      'points',
      point,
      'trueAnswer',
      trueAnswer,
      'statusTicket',
      trueAnswer ? trueAnswer / this.thisQuestions.length : 0,
    );
    return {
      point,
      status: trueAnswer ? trueAnswer / this.thisQuestions.length : 0,
    };
  }

  getResultTest() {
    const nTicket = this.activateRoute.snapshot.params['ticketId'] * 1;

    if (!this.currentUser.questions[nTicket]) {
      this.currentUser.questions[nTicket] = {
        a: [],
        s: 0,
      };
    }
    // Обновляем массив ответов
    this.currentUser.questions[nTicket].a = [...this.userAnswer];

    console.log(this.thisQuestions, this.userAnswer);

    var statusTicket = this.pointsCulculate();
    this.currentUser.point += statusTicket.point;

    console.log(
      'statusTicket',
      //statusTicketTest,
      statusTicket,
      this.questionsCount,
    );

    if (statusTicket.status == 1) {
      //зелёный, открывем след уровень
      this.currentUser.questions[nTicket].s = 3;
      //this.currentUser.questions[$stateParams.id*1 +1].s = 1;

      this.addNewTicket(nTicket + 1, 1);
    } else if (statusTicket.status > 0.5) {
      //жёлтый, открывем след уровень
      this.currentUser.questions[nTicket].s = 2;

      this.addNewTicket(nTicket + 1, 1);
      //$rootScope.dataUser.questions[$stateParams.id*1 +1].s = 1;
    }

    this.ticketsService.rebuildTicketsList();

    // 2 Записываем объект в localStora
    //
    //
    //
    //
    var ansQuestCount = 0,
      ollQuestions = 0;
    for (let el in this.currentUser.questions) {
      ansQuestCount += this.currentUser.questions[el].a.length;
    }

    TICKETS_CONSTANT.forEach((val, k) => {
      ollQuestions += val.questions.length;
    });

    const newStatusUser = ansQuestCount / ollQuestions;
    if (newStatusUser > 0.8) {
      this.currentUser.status = 4;
    } else if (newStatusUser > 0.6) {
      this.currentUser.status = 3;
    } else if (newStatusUser > 0.4) {
      this.currentUser.status = 2;
    } else if (newStatusUser > 0.2) {
      this.currentUser.status = 1;
    }

    this.dataUser.stUser =
      STATUS_USER.name[this.currentUser.status].lang[this.currentUser.lang];

    // Результат для шаринга: правильных ответов = баллы / 10
    const correct = Math.round(
      statusTicket.point / POINT_CONFIG.addPointTrueAns,
    );
    this.lastShareResult = {
      correct,
      total: this.questionsCount,
      ticketIndex: nTicket,
    };

    // Сохраняем обновленные данные через сеттер
    console.log('2');
    this.dataUser.user = this.currentUser;
    this.showResults = true;
  }

  async shareResult() {
    const lang = this.dataUser.user?.lang ?? 'ru';
    const baseUrl = `https://${lang}.${environment.resultUrl}/results/my_result.html`;
    const params = this.lastShareResult
      ? `correct=${this.lastShareResult.correct}&total=${this.lastShareResult.total}&ticket=${this.lastShareResult.ticketIndex}`
      : `result=${Math.floor(Math.random() * 1000000000)}`;
    const shareUrl = `${baseUrl}?${params}`;

    const shareData: ShareData = {
      title: this.translocoService.translate('tickets.share_title'),
      text:
        this.translocoService.translate('tickets.share_text') + ' ' + shareUrl,
      url: shareUrl,
    };

    if (typeof navigator.share === 'function') {
      const canShare = !navigator.canShare || navigator.canShare(shareData);
      if (canShare) {
        try {
          await navigator.share(shareData);
        } catch (error) {
          if ((error as Error).name !== 'AbortError') {
            console.log('Ошибка при шаринге:', error);
            await this.fallbackCopyToClipboard(shareUrl);
          }
        }
      } else {
        await this.fallbackCopyToClipboard(shareUrl);
      }
    } else {
      await this.fallbackCopyToClipboard(shareUrl);
    }
  }

  private async fallbackCopyToClipboard(text: string): Promise<void> {
    try {
      await navigator.clipboard.writeText(text);
      const message = this.translocoService.translate('tickets.link_copied');
      this.alerts
        .open(message, { appearance: 'success', autoClose: 3000 })
        .subscribe();
    } catch {
      console.log('Не удалось скопировать ссылку');
    }
  }
}
